export const CARD_DESCRIPTION_VARIANT: keyof NCoreUIKit.Typography = "bodyMediumSize";

export const CARD_DESCRIPTION_SKELETON_WIDTH = "40%";
